import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';

@Component({
  selector: 'ac-info-box',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBoxComponent {
  // Notification types (not default)
  @Input({ transform: booleanAttribute }) alert?: boolean | string;
  @Input({ transform: booleanAttribute }) complete?: boolean | string;
  @Input({ transform: booleanAttribute }) error?: boolean | string;
  @Input({ transform: booleanAttribute }) woutBorder?: boolean | string;
  // small notification => s:block md:inline width: auto (s:block md:block width:100% by default)
  @Input({ transform: booleanAttribute }) small?: boolean | string;
}
